// =============================================================================
// LANGUAGE SELECTOR COMPONENT
// =============================================================================
// Dropdown for selecting language in Admin portal
// Globe icon for accessibility and visibility
// =============================================================================

import { Globe } from 'lucide-react';
import { useTranslation, type LanguageCode } from './index';

interface LanguageSelectorProps {
  className?: string;
}

export function LanguageSelector({ className = '' }: LanguageSelectorProps) {
  const { language, setLanguage, languages, isLoading } = useTranslation();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Globe className="w-5 h-5 text-gray-500" />
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as LanguageCode)}
        disabled={isLoading}
        className="text-sm border-none bg-transparent focus:ring-0 cursor-pointer disabled:opacity-50"
        aria-label="Select language"
      >
        {Object.entries(languages).map(([code, config]) => (
          <option key={code} value={code}>
            {config.nativeName}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSelector;
